import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { AtendimentoPacienteList } from '../../../atendimento/core/_models'
import { HistoricoColumns } from './columns/_columns'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { useT } from '_metronic/i18n/Metronici18n'

export const HistoricoTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { hasFilters, clearFilters } = useListFilters()
  const { t } = useT()

  const columns = useMemo(() => HistoricoColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title='Nenhum atendimento encontrado'
      description='Revise o protocolo, o estado ou a data.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhum atendimento ainda'
      description='Os atendimentos deste paciente aparecem aqui.'
    />
  )

  return (
    <CustomTable<AtendimentoPacienteList>
      id='kt_table_historico'
      ariaLabel='Atendimentos do paciente'
      itemLabel={{ singular: 'atendimento', plural: 'atendimentos' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
